import { AnalyticsClient } from './AnalyticsClient';
import { AnalyticsEventName, AnalyticsEventParams } from './analyticsEvents';

export const GA_SCRIPT_ID = 'ga4-gtag-script';

type AnalyticsWindow = Window & {
  dataLayer?: unknown[];
  gtag?: (...args: unknown[]) => void;
};

export class Ga4AnalyticsClient implements AnalyticsClient {
  private hasInitialised = false;

  constructor(private readonly measurementId: string) {}

  initialise(): void {
    if (this.hasInitialised || !this.measurementId) {
      return;
    }

    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    this.injectScript();
    this.setupGlobalConfig();
    this.hasInitialised = true;
  }

  trackEvent(name: AnalyticsEventName, params: AnalyticsEventParams): void {
    const gtag = (window as AnalyticsWindow).gtag;
    if (typeof gtag !== 'function') {
      return;
    }

    gtag('event', name, params);
  }

  private injectScript(): void {
    if (document.getElementById(GA_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement('script');
    script.id = GA_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);
  }

  private setupGlobalConfig(): void {
    const analyticsWindow = window as AnalyticsWindow;
    analyticsWindow.dataLayer = analyticsWindow.dataLayer || [];

    if (!analyticsWindow.gtag) {
      analyticsWindow.gtag = function (...args: unknown[]): void {
        analyticsWindow.dataLayer?.push(arguments);
      };
    }

    analyticsWindow.gtag('js', new Date());
    analyticsWindow.gtag('config', this.measurementId);
  }
}
